import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_BASE } from '../../config';
import './TenantEditor.css';

const TenantEditor = () => {
  const { token } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    email: '',
    plan: 'FREE',
    role: 'USER',
    password: '',
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.name || !form.email || !form.password) {
      setError('Name, email, and password are required.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/admin/tenants`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error(`Failed: ${res.status}`);

      const data = await res.json();
      navigate(`/admin/tenants/${data.id}`);
    } catch (err) {
      setError(err.message || 'Failed to create tenant');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tenant-editor container">
      <h2 className="heading-lg">Create New Tenant</h2>

      {error && <div className="error-banner" role="alert">{error}</div>}

      <form className="tenant-form" onSubmit={handleSubmit} noValidate>
        <div className="form-group">
          <label htmlFor="name">Name <span aria-hidden="true">*</span></label>
          <input
            id="name"
            name="name"
            className="input"
            type="text"
            value={form.name}
            onChange={handleChange}
            required
            aria-required="true"
            aria-describedby="nameHelp"
            placeholder="Enter tenant name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email <span aria-hidden="true">*</span></label>
          <input
            id="email"
            name="email"
            className="input"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            aria-required="true"
            placeholder="example@domain.com"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password <span aria-hidden="true">*</span></label>
          <input
            id="password"
            name="password"
            className="input"
            type="password"
            value={form.password}
            onChange={handleChange}
            required
            aria-required="true"
            placeholder="Set a secure password"
          />
        </div>

        <div className="form-row">
          <div className="form-group flex-grow-1">
            <label htmlFor="plan">Plan</label>
            <select
              id="plan"
              name="plan"
              className="input"
              value={form.plan}
              onChange={handleChange}
            >
              <option value="FREE">FREE</option>
              <option value="PRO">PRO</option>
              <option value="ENTERPRISE">ENTERPRISE</option>
            </select>
          </div>

          <div className="form-group flex-grow-1">
            <label htmlFor="role">Role</label>
            <select
              id="role"
              name="role"
              className="input"
              value={form.role}
              onChange={handleChange}
            >
              <option value="USER">USER</option>
              <option value="MANAGER">MANAGER</option>
              <option value="ADMIN">ADMIN</option>
            </select>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading || !form.name || !form.email || !form.password}
          aria-disabled={loading || !form.name || !form.email || !form.password}
        >
          {loading ? 'Creating...' : 'Create Tenant'}
        </button>
      </form>
    </div>
  );
};

export default TenantEditor;
